import { render, staticRenderFns } from "./StartTaskDialog.vue?vue&type=template&id=3c53e4e6&scoped=true&"
import script from "./StartTaskDialog.vue?vue&type=script&lang=js&"
export * from "./StartTaskDialog.vue?vue&type=script&lang=js&"
import style0 from "./StartTaskDialog.vue?vue&type=style&index=0&id=3c53e4e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c53e4e6",
  null
  
)

export default component.exports